export default __webpack_public_path__ + "static/media/recipes-6.70d7e908.jpg";